import { useTranslation } from "react-i18next";
import { GridColDef, GridColumnHeaderParams, GridRenderCellParams } from "@mui/x-data-grid-pro";

import { LoadingSkeleton } from "../../../components/LoadingSkeleton";
import { TableAllWastesCell } from "../../../components/TableAllWastesCell";
import { TablePriceCell } from "../../../components/TablePriceCell";
import { TableWeightCell } from "../../../components/TableWeightCell";
import { IColumnAlignObject } from "../../../types/table";
import { getTableColumnUtils } from "../../../utils/tables/getTableColumnUtils";
import { CollectionYardVisitEventsTableHeaderCell } from "./CollectionYardVisitEventsTableHeaderCell/CollectionYardVisitEventsTableHeaderCell";

export enum CollectionYardVisitEventsTableColumnType {
  wasteTypeId = "wasteTypeId",
  netto = "netto",
  rate = "rate",
  price = "price",
}

const columnAlignObject: IColumnAlignObject<CollectionYardVisitEventsTableColumnType> = {
  left: [CollectionYardVisitEventsTableColumnType.wasteTypeId],
  right: [
    CollectionYardVisitEventsTableColumnType.netto,
    CollectionYardVisitEventsTableColumnType.rate,
    CollectionYardVisitEventsTableColumnType.price,
  ],
};

export const useGetCollectionYardVisitEventsTableColumns = () => {
  const { t } = useTranslation();
  const { getAlign } = getTableColumnUtils();

  const columns: GridColDef[] = Object.values(CollectionYardVisitEventsTableColumnType).map((label) => {
    const column: GridColDef = {
      field: label,
      headerName: t(label),
      flex: 1,
      type: "string",
      headerAlign: getAlign(label, columnAlignObject),
      align: getAlign(label, columnAlignObject),
      renderHeader: (params: GridColumnHeaderParams) => {
        return <CollectionYardVisitEventsTableHeaderCell params={params} />;
      },
      renderCell: (params: GridRenderCellParams<any>) => {
        if (params.row.isMocked) {
          return <LoadingSkeleton />;
        }

        switch (label) {
          case CollectionYardVisitEventsTableColumnType.wasteTypeId:
            return <TableAllWastesCell params={params} />;

          case CollectionYardVisitEventsTableColumnType.netto:
            return <TableWeightCell params={params} />;

          case CollectionYardVisitEventsTableColumnType.rate:
            return <TablePriceCell params={params} />;

          case CollectionYardVisitEventsTableColumnType.price:
            return <TablePriceCell params={params} />;
          default:
            return <div>{params.value}</div>;
        }
      },
    };

    return column;
  });

  return columns;
};
